import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-129c6f04"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bindTip"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "bindName"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "form-item" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "label-title" }
const _hoisted_9 = { class: "err-msg" }
const _hoisted_10 = { class: "form-item" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "label-title" }
const _hoisted_13 = { class: "err-msg" }
const _hoisted_14 = { class: "forgot-password" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "form-item" }
const _hoisted_17 = { class: "label" }
const _hoisted_18 = { class: "label-title" }
const _hoisted_19 = { class: "err-msg" }
const _hoisted_20 = { class: "form-item" }
const _hoisted_21 = {
  key: 0,
  class: "label"
}
const _hoisted_22 = {
  key: 0,
  class: "sendCodetips"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/login/icon_Attention.png",
  alt: ""
}, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 認証コードを送信しました。 ")
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 迷惑メールフォルダもご確認のうえ、30分以内にコードをご入力ください。 ")
const _hoisted_27 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "form-item verifyCode" }
const _hoisted_29 = { class: "label" }
const _hoisted_30 = { class: "label-title" }
const _hoisted_31 = { class: "err-msg" }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { class: "form-item" }
const _hoisted_34 = { class: "label" }
const _hoisted_35 = { class: "label-title" }
const _hoisted_36 = { class: "err-msg" }
const _hoisted_37 = { class: "form-item" }
const _hoisted_38 = {
  key: 0,
  class: "label"
}
const _hoisted_39 = {
  key: 0,
  class: "sendCodetips"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/login/icon_Attention.png",
  alt: ""
}, null, -1))
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" 認証コードを送信しました。")
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" 迷惑メールフォルダもご確認のうえ、30分以内にコードをご入力ください。 ")
const _hoisted_44 = [
  _hoisted_40,
  _hoisted_41,
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = { class: "form-item verifyCode" }
const _hoisted_46 = { class: "label" }
const _hoisted_47 = { class: "label-title" }
const _hoisted_48 = { class: "err-msg" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_50 = {
  key: 1,
  class: "other_page"
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "other_method" }
const _hoisted_53 = { class: "platfroms" }
const _hoisted_54 = ["data-key", "onClickPassive"]
const _hoisted_55 = ["src", "alt"]
const _hoisted_56 = {
  key: 3,
  style: {"margin-top":"16px"}
}
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = {
  key: 1,
  class: "to-sign-platform"
}
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" まだTHE CKBアカウントをお持ちでない方は、")
const _hoisted_60 = /*#__PURE__*/_createTextVNode("からご登録・連携を行ってください。 ")

import { reactive, ref, computed, onMounted, onUnmounted, nextTick, watch, onActivated } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElMessageBox, useModal } from 'element-plus'
import { changeLang, t } from '@/plugins/i18n'
import { UserInfo, openAuth2, Plat, platType, APPLE_USER, continueLogin, AUTH_PLAT } from '@/plugins/tripartite-login'
import {
  loginByPwd,
  loginByCode,
  getLoginCode,
  isBind,
  mobileLogin,
  getMobileCode, MobileCodeParams, setDefault
} from '@/apis/login'
import { compTripartitePlatforms, countryType, BizType, CountriesEnum, UseType, Site } from '@/common/const'
import LogoSrc from '@/assets/image/icon/logo.png'
import { R, useSite, isJA, isKO } from '@/store'
import { getCountryCodeList } from '@/common/utils'
import { TripartiteUserInfo, UPDATE_TRIPARTITEUSERINFO, REMOVE_TRIPARTITEUSERINFO } from '@/store/modules/tripartite'
import { useGetCode, LoginMode } from './utils'
import { login as createRules } from './rules'
import caches from '@/plugins/cache'
import LoginIntroduce from '@/views/signup/components/LoginIntroduce.vue'
import { locale } from 'dayjs'
interface Props {
  h5?: boolean
  isRam?: boolean
  hiddenClose?: boolean
  // 详情页登陆
  isDetail?: boolean
}
// 提交表单申明
interface Form {
  nameOrEmail?: string
  password?: string
  customerEmail?: string
  verificationCode?: string
  customerMobile?: string
  countryCode?: string
  nationCode?: string
  recaptchaCode?: '' // 谷歌人机密码code
  platformType?: 1 // 1:PC  2: app
  globalRoaming?: string // 区号
}

/** 手机号前缀 */

export default /*#__PURE__*/_defineComponent({
  props: {
    h5: { type: Boolean, required: false },
    isRam: { type: Boolean, required: false },
    hiddenClose: { type: Boolean, required: false },
    isDetail: { type: Boolean, required: false }
  },
  emits: ['onsuccess', 'update:panel'],
  setup(__props: any, { emit }) {

const props = __props as {
  h5?: boolean
  isRam?: boolean
  hiddenClose?: boolean
  // 详情页登陆
  isDetail?: boolean
}
const store = useStore<R>()

const goToLine = () => {
  window.location.href = '/hub/line'
}

const lineActivity = computed(() => store.getters.lineActivity)

const capitalizeFirstLetter = (str: string) => {
  if (!str) return '' // 处理空字符串
  return str.charAt(0).toUpperCase() + str.slice(1)
}

const capPlatform = computed(() => {
  return capitalizeFirstLetter(loginPlatform.value ?? '')
})
const mobileAreaCodeOptions = ref<{ value: string; label: string }[]>([])

const loginModeList: { type: LoginMode, name: string }[] = [
  {
    type: LoginMode.password,
    name: t('密码登录')
  },
  {
    type: LoginMode.email,
    name: t('邮箱验证码登录')
  },
  {
    type: LoginMode.phone,
    name: t('手机号验证码登录')
  }
]




const router = useRouter()
const route = useRoute()
const site = useSite()
/** 登录Logo */
const loginLogo = ref(LogoSrc)
/** 登录模式 */
const loginMode = ref<LoginMode>(LoginMode.email)
/** 三方授权平台 */
const loginPlatform = ref<string>()
/** 展示密码 */
const showPassWord = ref(false)
/** 三方平台信息 */
const tripartitePlatfromInfo = computed<TripartiteUserInfo>(() => store.state.tripartite)
const loading = ref(false)
const formRef = ref()

// 轮询 返回 true 截止轮训
const createIntervalProlling = (ms: number, timeout: number) => {
  let passMs = 0
  return (handleFunction: () => boolean, prollingEndFunction: (isProllingSuccess: boolean) => void) => {
    const interval = setInterval(() => {
      passMs += ms
      const isProllingSuccess = handleFunction()
      if (isProllingSuccess || passMs >= timeout) {
        clearInterval(interval)
        prollingEndFunction(isProllingSuccess)
      }
    }, ms)
  }
}

const setIntervalProlling = createIntervalProlling(100, 4000)
/** 提交表单 */
const form = reactive<Form>({
  nameOrEmail: '',
  password: '',
  customerEmail: '',
  verificationCode: '',
  customerMobile: '',
  recaptchaCode: '', // 谷歌人机密码code
  platformType: 1, // 1:PC  2: app
  countryCode: '+81'
})
/** 站点过滤国家 */
const countries = ref<countryType[]>([])

const {
  count,
  tip,
  disabled,
  getCode,
  getPhoneCode
} = useGetCode('loginCode', getLoginCode, getMobileCode)
/** 发送验证码 */
const sendCode = async () => {
  if (count.value > 0) return
  if (loginMode.value === LoginMode.email) {
    const checkResult = await formRef.value.validateField([
      'customerEmail'
    ])
    if (checkResult) {
      getCode(form.customerEmail as string)
    }
  }
  if (loginMode.value === LoginMode.phone) {
    const checkResult = await formRef.value.validateField([
      'customerMobile'
    ])
    if (checkResult) {
      const data = { customerMobile: form.customerMobile, globalRoaming: form.countryCode, bizType: BizType.LOGIN } as MobileCodeParams
      getPhoneCode(data)
    }
  }
}

/** 切换登录模式 */
const changeMode = (mode: LoginMode) => {
  loginMode.value = mode
}
/** 切换三方平台信息 */
const changeLoginPlatfrom = (platform: platType) => {
  loginPlatform.value = platform
}
/** 创建提交表单规则 */
const rules = createRules(disabled)

/** 登录接口 */
const _signin = async (form: any, isBind: boolean) => {
  let api: any = loginByPwd
  switch (loginMode.value) {
    case LoginMode.email:
      api = loginByCode
      break
    case LoginMode.password:
      api = loginByPwd
      break
    case LoginMode.phone:
      api = mobileLogin
      break
  }
  // 三方登录强制通过code登录
  if (form.thirdPlatform && form.thirdCustomerId && isBind) {
    api = loginByPwd
  }
  try {
    loading.value = true
    const res = await api({ ...form, globalRoaming: form.countryCode })
    if (res.code === '240300029') {
      ElMessageBox({
        title: 'ACCESS ERROR',
        message: 'US users, please visit SellerStation to access our services. Thank you~',
        confirmButtonText: 'Go to',
        cancelButtonText: 'Cancel',
        type: 'warning',
        showClose: false
      }).then(() => {
        location.href = 'https://sellerstation.com/'
      })
      return
    }
    if (res?.success) {
      store.commit('status/onLogin', false)
      // 第一次注册，选择完平台后
      if (res.data.uuid && !res.data.token) {
        store.commit('route/uuid', res.data.uuid)
        store.commit('route/SET_LOGIN_NAME', form.nameOrEmail)
        // 如果携带直营商城参数登录问题
        if (route.query.from) {
          const res1 = await setDefault({ uuid: res.data.uuid, systemSource: UseType.d2d })
          await store.dispatch('route/changeToken', res1.data.token)
          if (res1.success) {
            location.replace(route.query.from as string)
          }
          return
        }
        if (props.h5) {
          router.replace({ name: 'signup_h5' })
        } else {
          router.replace({ name: 'signup' })
        }
      } else {
        // 是否弹出取消订单弹窗
        localStorage.setItem('cancelOrderShow', '0')
        // 是否刚登陆
        localStorage.setItem('isLoginNow', '1')
        // 是否刚登陆弹窗提示一价全包附加项设置
        localStorage.setItem('isConfimAdditionLoginNow', '1')
        const query = route.query
        const { redirect, from } = query ?? {}
        // 仅日本站带from字段才跳转直营商城/默认登录信息为直营商城
        if (res.data.customerRespDTO.nationCode === CountriesEnum.Japan && from) {
          // 子账号直接登录直营
          if (res.data.customerRespDTO.accountType === 2) {
            await store.dispatch('route/refreshToken', res.data.token)
            return false
          }
          await store.dispatch('route/changeToken', res.data.token)
          // 保证token已经设置好，跳转到其他工程的时候可以拿到 cookie
          setIntervalProlling(() => {
            console.log('setIntervalProlling', caches.get('route/token'))
            return Boolean(caches.get('route/token'))
          }, () => {
            window.location.replace(decodeURIComponent(from.toString()))
          })
        } else if (redirect) {
          await store.dispatch('route/changeToken', res.data.token)
          // window.location.replace(decodeURIComponent(redirect.toString()))
          // 保证token已经设置好，跳转到其他工程的时候可以拿到 cookie
          setIntervalProlling(() => {
            console.log('setIntervalProlling', caches.get('route/token'))
            return Boolean(caches.get('route/token'))
          }, () => {
            if (process.env.NODE_ENV === 'development') {
              router.push(redirect.toString())
            } else {
              window.location.replace(decodeURIComponent(redirect.toString()))
            }
          })
        } else {
          store.commit('route/token', res.data.token)
          router.push('/')
          localStorage.setItem('_reload_page_', Math.random().toString().slice(2))
        }
      }
    } else {
      if (res?.code === '24010003' && form.recaptchaCode) {
        form.recaptchaCode = ''
      }
    }
  } catch (error) {
    console.log(error)
    ElMessage.error(t('登录失败'))
  } finally {
    loading.value = false
  }
}

/** 根据用户是否绑定过CKB，判断直接登录/绑定CKB */
const bindOrLogin = async (info?: UserInfo) => {
  try {
    const res = await isBind({
      thirdPlatform: info?.thirdPlatform,
      thirdCustomerId: info?.thirdCustomerId
    })
    if (res.success) {
      const isbind = res.data?.isBind
      // 已经绑定过我们的账号,直接登录
      if (isbind) {
        _signin({
          thirdPlatform: info?.thirdPlatform as string,
          thirdCustomerId: info?.thirdCustomerId as string
        }, true)
      } else {
        changeLoginPlatfrom(info?.thirdPlatform as Plat)
      }
    }
  } catch (error) {
  }
}

const loginByPlatform = async (platform: Plat) => {
  // 若用户已经授权过某个平台,store中的值等于当前点击的平台，则直接登录
  if (tripartitePlatfromInfo.value.thirdPlatform === platform) {
    bindOrLogin(tripartitePlatfromInfo.value as UserInfo)
    return
  }

  openAuth2(
    {
      plat: platform,
      h5: props.h5
    },
    async (rsp) => {
      bindOrLogin(rsp?.userInfo)
    }
  )
}

const toSignup = () => {
  const path = window.location.href
  // 若当前不是在/login,则应该是切换弹窗
  if (!path.includes('login')) {
    store.commit('status/loginPanel', 'signUp')
  } else {
    // H5直接跳转h5到
    if (props.h5) {
      router.push('/signup_h5' + window.location.search)
    } else {
      router.push('/signup')
    }
  }
}
/** 三方平台绑定登录 */
const bindPlatform = async () => {
  const checkResult = await formRef.value.validate()
  if (!checkResult || !loginPlatform.value) return
  _signin({
    ...form,
    ...tripartitePlatfromInfo.value
  }, false)
}
/** 注册点击 */
const signin = async () => {
  const valid = await formRef.value.validate()
  if (!valid) return
  _signin(form, false)
}
const timer = ref(null)
// 在 script setup 中添加
const handleAppleUserLogin = () => {
  console.log('我触发了');
  if (localStorage.getItem(APPLE_USER)) {
    continueLogin(async (rsp: any) => {
      bindOrLogin(rsp?.userInfo)
      loginPlatform.value = localStorage.getItem(AUTH_PLAT)!
    })
  }
}

onMounted(() => {
  if (route.query.needGotoLoginH5) {
    sessionStorage.setItem('needGotoLoginH5', '1')
  }
  if (tripartitePlatfromInfo.value?.thirdPlatform) {
    loginPlatform.value = tripartitePlatfromInfo.value.thirdPlatform
  }
  handleAppleUserLogin()
  // loginPlatform.value = 'google'
  // 根据语言判断logo
  loginLogo.value = 'https://static-jp.theckb.com/static-asset/client/loginLogo.svg'
  if (route.query.from && !isJA()) {
    changeLang('ja')
    localStorage.setItem('countryKey', 'JP')
    store.commit('route/site', 'ja')
    setTimeout(() => {
      location.reload()
    }, 1)
  }

  // 区号列表
  const list = getCountryCodeList()
  countries.value = list
  mobileAreaCodeOptions.value = list.map(i => {
    return {
      label: i.mobileAreaCode,
      value: i.mobileAreaCode
    }
  }).concat({
    label: '—',
    value: ''
  })
  nextTick(() => {
    form.countryCode = list[0].mobileAreaCode
    // form.countryPlaceCode = list[0].key
  })
})

onUnmounted(() => {
  clearInterval(timer.value)
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["LoginForm", { login_h5: __props.h5 }])
  }, [
    (loginPlatform.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "bindInfo",
            innerHTML: _unref(t)('绑定您的THE CKB账户')
          }, null, 8, _hoisted_2),
          (_unref(isJA)())
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "ログイン後、" + _toDisplayString(loginPlatform.value) + "アカウントと連携できます", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)('只需绑定一次，后续可用{platform}直接登录', {
          platform: _unref(capPlatform)
        })), 1))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form, {
      ref: (_value, _refs) => {
        _refs['formRef'] = _value
        formRef.value = _value
      },
      model: _unref(form),
      rules: _unref(rules),
      class: _normalizeClass(__props.h5 && 'login_h5_form')
    }, {
      default: _withCtx(() => [
        (loginMode.value === _unref(LoginMode).password)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('登录名/邮箱')), 1)
                ]),
                _createVNode(_component_el_form_item, { prop: "nameOrEmail" }, {
                  error: _withCtx((error) => [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(error.error), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: _unref(isJA)() ? 'ユーザー名をご入力ください' : '',
                      type: "text",
                      modelValue: _unref(form).nameOrEmail,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).nameOrEmail) = $event)),
                      modelModifiers: { trim: true }
                    }, null, 8, ["placeholder", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('密码')), 1)
                ]),
                _createVNode(_component_el_form_item, {
                  prop: "password",
                  id: "password"
                }, {
                  error: _withCtx((error) => [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(error.error), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: _unref(isJA)() ? 'パスワードをご入力ください' : '',
                      type: showPassWord.value ? 'text' : 'password',
                      modelValue: _unref(form).password,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).password) = $event)),
                      modelModifiers: { trim: true },
                      maxlength: 32,
                      onBlur: _cache[3] || (_cache[3] = ($event: any) => (formRef.value.validateField(['password', 'repassword'])))
                    }, {
                      suffix: _withCtx(() => [
                        _createElementVNode("i", {
                          class: _normalizeClass(["password-suffix", showPassWord.value
                  ? 'iconfont icon-zhengyan'
                  : 'iconfont icon-biyan'
                  ]),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (showPassWord.value = !showPassWord.value))
                        }, null, 2)
                      ]),
                      _: 1
                    }, 8, ["placeholder", "type", "modelValue"]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_router_link, {
                        to: "/login/findpwd",
                        class: "forgot-password"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(loginMode.value === _unref(LoginMode).password ? `${_unref(t)('忘记密码')}${!_unref(isKO) ? '?' : ''}` : ''), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (loginMode.value === _unref(LoginMode).phone)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)('手机号登录')), 1)
                ]),
                _createVNode(_component_el_form_item, { prop: "customerMobile" }, {
                  error: _withCtx((error) => [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(error.error), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: _unref(isJA)() ? '例: 07012345678' : '',
                      type: "phone",
                      modelValue: _unref(form).customerMobile,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).customerMobile) = $event)),
                      modelModifiers: { trim: true },
                      maxlength: 50,
                      class: _normalizeClass(props.h5 ? 'phone-input-h5' : 'phone-input')
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          "popper-class": "sign-popper-class",
                          class: "countryCode",
                          modelValue: _unref(form).countryCode,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).countryCode) = $event)),
                          style: {"width":"68px"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileAreaCodeOptions.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["placeholder", "modelValue", "class"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_20, [
                (!__props.h5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "sendCode",
                      color: "#FEEEE8",
                      onClick: sendCode,
                      disabled: _unref(count) > 0
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(count) > 0 ? _unref(tip) :
              _unref(t)('获取验证码')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              (_unref(count) && _unref(isJA)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_27))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(t)('手机验证码')), 1)
                ]),
                _createVNode(_component_el_form_item, { prop: "verificationCode" }, {
                  error: _withCtx((error) => [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(error.error), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: _unref(isJA)() ? '認証コードをご入力ください' : '',
                      type: "number",
                      modelValue: _unref(form).verificationCode,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).verificationCode) = $event)),
                      modelModifiers: { trim: true }
                    }, null, 8, ["placeholder", "modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (loginMode.value === _unref(LoginMode).email)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(t)('邮箱地址')), 1)
                ]),
                _createVNode(_component_el_form_item, { prop: "customerEmail" }, {
                  error: _withCtx((error) => [
                    _createElementVNode("div", _hoisted_36, _toDisplayString(error.error), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "email",
                      placeholder: _unref(isJA)() ? '例: yamada@sniffjapan.com' : '',
                      modelValue: _unref(form).customerEmail,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).customerEmail) = $event)),
                      modelModifiers: { trim: true }
                    }, null, 8, ["placeholder", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_37, [
                (!__props.h5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "sendCode",
                      color: "#FEEEE8",
                      disabled: _unref(count) > 0,
                      onClick: sendCode
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(count) > 0 ? _unref(tip) :
              _unref(t)('获取验证码')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              (_unref(count) && _unref(isJA)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_44))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(t)('邮箱验证码')), 1)
                ]),
                _createVNode(_component_el_form_item, { prop: "verificationCode" }, {
                  error: _withCtx((error) => [
                    _createElementVNode("div", _hoisted_48, _toDisplayString(error.error), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: _unref(isJA)() ? '認証コードをご入力ください' : '',
                      modelValue: _unref(form).verificationCode,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).verificationCode) = $event)),
                      modelModifiers: { trim: true }
                    }, null, 8, ["placeholder", "modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model", "rules", "class"]),
    _createElementVNode("div", {
      class: _normalizeClass(__props.h5 && 'login_h5_submit')
    }, [
      (loginPlatform.value)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            color: "#FA541C",
            class: "loginBtn",
            loading: loading.value,
            onClick: bindPlatform
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(capPlatform)) + " ", 1),
              _hoisted_49,
              _createTextVNode(" " + _toDisplayString(_unref(t)('确认绑定')), 1)
            ]),
            _: 1
          }, 8, ["loading"]))
        : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            color: "#FA541C",
            class: "loginBtn",
            loading: loading.value,
            onClick: signin
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('登录')), 1)
            ]),
            _: 1
          }, 8, ["loading"]))
    ], 2),
    (!loginPlatform.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("span", {
            onClick: toSignup,
            class: "to-sign"
          }, _toDisplayString(_unref(t)('去注册')), 1),
          (!props.isRam)
            ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                _createVNode(_component_el_divider, { direction: "vertical" }),
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "to-index"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('首页')), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!loginPlatform.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(_component_el_divider, null, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_52, _toDisplayString(_unref(t)('其他登录方法')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_53, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(compTripartitePlatforms), (platform) => {
              return (_openBlock(), _createElementBlock("div", {
                key: platform.key,
                class: _normalizeClass(["platform", platform.key]),
                "data-key": platform.key,
                onClickPassive: ($event: any) => (loginByPlatform(platform.key))
              }, [
                _createElementVNode("img", {
                  src: platform.logoUrl,
                  alt: _unref(t)('平台logo'),
                  height: "30",
                  width: "30"
                }, null, 8, _hoisted_55)
              ], 42, _hoisted_54))
            }), 128))
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_56)),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(loginModeList, (item) => {
      return _createElementVNode("div", {
        key: item.name
      }, [
        (loginMode.value !== item.type)
          ? (_openBlock(), _createBlock(_component_el_button, {
              class: "change-mode",
              onClick: ($event: any) => (changeMode(item.type)),
              key: item.name
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    }), 64)),
    (loginPlatform.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          (!_unref(isJA)())
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "to-sign-platform",
                onClick: toSignup,
                innerHTML: _unref(t)('还没有CKB账户，现在去【注册并绑定】')
              }, null, 8, _hoisted_57))
            : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("span", { onClick: toSignup }, "こちら"),
                _hoisted_60
              ]))
        ], 64))
      : _createCommentVNode("", true),
    (__props.h5)
      ? (_openBlock(), _createBlock(LoginIntroduce, {
          key: 5,
          h5: true
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})